import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'subscription',
    path: '/subscription',
    component: () => import('../pages/SubscriptionPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
